import { render, staticRenderFns } from "./WaterForm.vue?vue&type=template&id=538df555"
import script from "./WaterForm.vue?vue&type=script&lang=js"
export * from "./WaterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports